import {NgModule} from '@angular/core';
import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
import {MatButtonModule} from '@angular/material/button';
import {SharedModule} from '../../shared/shared.module';
import {ChatPipesModule} from './shared/pipes/pipes.module';
import {PickersBuilder} from './shared/pickers-builder';
import {KeysReplacer} from './shared/keys-replacer';
import {MessageModule} from './components/message/message.module';
import {AnswersModule} from './components/answers/answers.module';
import {ChatComponent} from './chat.component';
import {LoadingModule} from '../../components/loading/loading.module';


@NgModule({
  imports: [
    MatBottomSheetModule,
    MatButtonModule,
    SharedModule,
    ChatPipesModule,
    MessageModule,
    AnswersModule,
    LoadingModule
  ],
  providers: [
    PickersBuilder,
    KeysReplacer
  ],
  declarations: [
    ChatComponent
  ]
})

export class ChatModule {}
